export default __webpack_public_path__ + "static/smiley-83027365261c581510237fc2da604026.jpg";